/* ============================================================
   Wav Monopoly — Preset PDP "Buy more, save more" bundle.
   CART-BACKED — shares one model with the Bundle Builder page
   (wm-bundle.js). The bundle "deal" panel is a live view of the
   CART:
     - Add (modal cards) -> POST /cart/add.js immediately, tagged
       with the hidden property _wm_bundle (+ Compatibility for WMA).
     - Remove (slot ×)   -> POST /cart/change.js (line key -> 0).
     - The PDP's OWN product is pick #1 ("primary"). Its variant
       comes from the "Select your software" buttons. Selecting a
       DAW only previews the price; the primary joins the cart when
       the shopper clicks the main Add button (then we go to /cart).
     - On every page load the panel rebuilds from /cart.js, so picks
       persist across pages and stay in sync with the collection
       bundle. If the primary is already in the cart (e.g. added on
       a collection page), its chosen variant is reflected here.
   Same _wm_bundle contract as wm-bundle.js, so both stay in sync.
   ============================================================ */
(function () {
  'use strict';

  var CART_PROP = '_wm_bundle';                 // hidden line-item property tagging bundle items
  var SECTIONS = ['cart-icon-bubble', 'cart-drawer'];

  function init(root) {
    if (!root || root.dataset.wmPbReady === 'true') return;
    root.dataset.wmPbReady = 'true';

    /* ----------------------------- config ----------------------------- */
    var cfg = {};
    var cfgEl = root.querySelector('[data-pb-config]');
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var MONEY_FORMAT = cfg.moneyFormat || '${{amount}}';
    var CART_ADD_URL = cfg.cartAddUrl || '/cart/add.js';
    var REDIRECT = cfg.redirect || '/cart';
    var TIERS = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
    var MAX_SLOTS = cfg.maxSlots || 3;
    var primary = cfg.primary || null; // { productId, title, image, price, compareAt }
    var WMA = cfg.wma || null;         // { value, pluginUrl, ctaLabel, subscribed, note }
    var STANDALONE = (primary && primary.price) || 0; // non-WMA price for the default render
    var STANDALONE_COMPARE = (primary && primary.compareAt) || 0; // keeps a genuine sale's strike on the default render

    /* ----------------------------- elements ----------------------------- */
    var dawButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pb-daw]'));
    var verButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pb-ver]'));
    var hasVer = verButtons.length > 0;
    var swHint = root.querySelector('[data-pb-sw-current]');
    var pVariants = [];
    try { pVariants = JSON.parse((root.querySelector('[data-pb-variants]') || {}).textContent || '[]'); } catch (e) { pVariants = []; }
    var selectedDaw = null, selectedVer = null;
    var soldOut = false;
    var stopEls = Array.prototype.slice.call(root.querySelectorAll('[data-tier-qty]'));
    var tiersEl = root.querySelector('[data-pb-tiers]');
    var MAX_PICKS = stopEls.length || MAX_SLOTS;
    var totalEl = root.querySelector('[data-pb-total]');
    var totalWasEl = root.querySelector('[data-pb-total-was]');
    var saveEl = root.querySelector('[data-pb-save]');
    var saveAmtEl = root.querySelector('[data-pb-save-amt]');
    var checkoutBtn = root.querySelector('[data-pb-checkout]');
    var noteEl = root.querySelector('[data-pb-note]');
    var errorEl = root.querySelector('[data-pb-error]');
    var addCountEl = root.querySelector('[data-pb-addcount]');

    // modal
    var modal = root.querySelector('[data-pb-modal]');
    var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pb-open]'));
    var grid = modal ? modal.querySelector('[data-bundle-grid]') : null;
    var cards = modal ? Array.prototype.slice.call(modal.querySelectorAll('[data-bundle-card]')) : [];
    var emptyEl = modal ? modal.querySelector('[data-bundle-empty]') : null;
    var searchInput = modal ? modal.querySelector('[data-bundle-search]') : null;
    var searchClear = modal ? modal.querySelector('[data-bundle-search-clear]') : null;
    var sortSelect = modal ? modal.querySelector('[data-bundle-sort]') : null;
    var dawSelect = modal ? modal.querySelector('[data-bundle-daw]') : null;
    var lastFocus = null;

    var sticky = document.createElement('div');
    sticky.className = 'wm-purchase-bar';
    sticky.hidden = true;
    sticky.setAttribute('role', 'region');
    sticky.setAttribute('aria-label', 'Preset purchase');
    var stickyInfo = document.createElement('div');
    stickyInfo.className = 'wm-purchase-bar__info';
    var stickyTitle = document.createElement('strong');
    stickyTitle.textContent = (primary && primary.title) || '';
    var stickyDetail = document.createElement('span');
    var stickyBundle = document.createElement('button');
    stickyBundle.type = 'button';
    stickyBundle.className = 'wm-purchase-bar__bundle';
    var stickyAction = document.createElement('button');
    stickyAction.type = 'button';
    stickyAction.className = 'wm-purchase-bar__action';
    var stickyError = document.createElement('span');
    stickyError.className = 'wm-purchase-bar__error';
    stickyError.setAttribute('role', 'status');
    stickyInfo.append(stickyTitle, stickyDetail, stickyBundle);
    sticky.append(stickyInfo, stickyAction, stickyError);
    root.appendChild(sticky);

    var softwarePicker = document.createElement('dialog');
    softwarePicker.className = 'wm-software-picker';
    softwarePicker.setAttribute('aria-label', 'Choose your software');
    var pickerClose = document.createElement('button');
    pickerClose.type = 'button';
    pickerClose.className = 'wm-software-picker__close';
    pickerClose.textContent = '×';
    pickerClose.setAttribute('aria-label', 'Close software picker');
    var pickerTitle = document.createElement('h2');
    pickerTitle.textContent = 'Choose your software';
    var pickerIntro = document.createElement('p');
    pickerIntro.textContent = 'Select the DAW you record in to get the right preset.';
    softwarePicker.append(pickerClose, pickerTitle, pickerIntro);
    var pickerChoices = [];
    function addPickerChoices(label, originals, select) {
      if (!originals.length) return;
      var fieldset = document.createElement('fieldset');
      var legend = document.createElement('legend');
      legend.textContent = label;
      fieldset.appendChild(legend);
      originals.forEach(function (original) {
        var choice = document.createElement('button');
        choice.type = 'button';
        choice.className = 'wm-software-picker__choice';
        choice.textContent = original.textContent.trim();
        choice.addEventListener('click', function () {
          if (busy) return;
          select(original);
          renderSoftwarePicker();
        });
        pickerChoices.push({ button: choice, original: original });
        fieldset.appendChild(choice);
      });
      softwarePicker.appendChild(fieldset);
    }
    addPickerChoices('Software / DAW', dawButtons, selectDaw);
    addPickerChoices('Version', verButtons, selectVer);
    var pickerConfirm = document.createElement('button');
    pickerConfirm.type = 'button';
    pickerConfirm.className = 'wm-purchase-bar__action wm-software-picker__confirm';
    var pickerStatus = document.createElement('p');
    pickerStatus.className = 'wm-software-picker__status';
    pickerStatus.setAttribute('role', 'status');
    softwarePicker.append(pickerConfirm, pickerStatus);
    root.appendChild(softwarePicker);
    pickerClose.addEventListener('click', function () { softwarePicker.close(); });
    softwarePicker.addEventListener('close', function () { stickyAction.focus({ preventScroll: true }); });
    softwarePicker.addEventListener('click', function (e) {
      if (e.target !== softwarePicker) return;
      var rect = softwarePicker.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) softwarePicker.close();
    });
    pickerConfirm.addEventListener('click', function () {
      if (!busy && checkoutBtn && !checkoutBtn.disabled) primaryAction();
    });
    function renderSoftwarePicker() {
      if (!checkoutBtn) return;
      pickerChoices.forEach(function (item) {
        item.button.disabled = busy || item.original.disabled;
        item.button.setAttribute('aria-pressed', item.original.getAttribute('aria-pressed') || 'false');
      });
      pickerConfirm.disabled = busy || checkoutBtn.disabled;
      pickerConfirm.setAttribute('aria-busy', busy ? 'true' : 'false');
      pickerConfirm.textContent = busy ? 'Adding…' : checkoutBtn.textContent.trim();
      pickerStatus.textContent = errorEl && !errorEl.hidden ? errorEl.textContent : '';
    }

    var stickyHeader = document.querySelector('.section-header');
    function updateStickyVisibility() {
      if (!checkoutBtn) return;
      var headerBottom = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) : 0;
      sticky.style.setProperty('--wm-purchase-top', headerBottom + 'px');
      sticky.hidden = checkoutBtn.getBoundingClientRect().bottom >= headerBottom || !!(modal && !modal.hidden);
    }
    function renderSticky() {
      if (!checkoutBtn) return;
      var r = compute();
      stickyDetail.textContent = [selectedDaw, selectedVer].filter(Boolean).join(' · ');
      stickyAction.textContent = checkoutBtn.disabled && !soldOut ? (checkoutBtn.getAttribute('data-label-single') || 'Add to cart') : checkoutBtn.textContent.trim();
      stickyAction.disabled = busy || (checkoutBtn.disabled && soldOut);
      stickyAction.setAttribute('aria-busy', busy ? 'true' : 'false');
      var next = nextTier(Math.max(1, r.count));
      stickyBundle.hidden = !next || r.count >= MAX_PICKS || !modal;
      if (next) stickyBundle.textContent = 'Add ' + (next.qty - Math.max(1, r.count)) + ' more preset' + ((next.qty - Math.max(1, r.count)) === 1 ? '' : 's') + ' & save ' + next.pct + '%';
      stickyBundle.disabled = busy;
      stickyError.textContent = errorEl && !errorEl.hidden ? errorEl.textContent : '';
      updateStickyVisibility();
      renderSoftwarePicker();
    }
    stickyAction.addEventListener('click', function () {
      if (busy) return;
      if (checkoutBtn.disabled) {
        renderSoftwarePicker();
        softwarePicker.showModal();
      } else primaryAction();
    });
    stickyBundle.addEventListener('click', openModal);
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    var stickyHeaderObserver = new ResizeObserver(updateStickyVisibility);
    if (stickyHeader) stickyHeaderObserver.observe(stickyHeader);
    var stickyObserver = new IntersectionObserver(updateStickyVisibility, { threshold: [0, 1] });
    if (checkoutBtn) stickyObserver.observe(checkoutBtn);
    var stickyStateObserver = new MutationObserver(renderSticky);
    if (errorEl) stickyStateObserver.observe(errorEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('shopify:section:unload', function cleanupSticky(e) {
      if (!e.target.contains(root)) return;
      window.removeEventListener('scroll', updateStickyVisibility);
      window.removeEventListener('resize', updateStickyVisibility);
      if (softwarePicker.open) softwarePicker.close();
      softwarePicker.remove();
      stickyHeaderObserver.disconnect();
      stickyObserver.disconnect();
      stickyStateObserver.disconnect();
      document.removeEventListener('shopify:section:unload', cleanupSticky);
    });

    /* ----------------------------- state ----------------------------- */
    // cartPicks: productId -> { productId, variantId, price, title, image, key, wma }
    //   — a mirror of the cart's _wm_bundle lines (includes the primary once it's added).
    var cartPicks = {};
    // pendingPrimary: the primary's selected-but-not-yet-in-cart pick (display + preview only).
    var pendingPrimary = null;
    var defaultPrimaryPick = null; // single-variant products: the lone variant as a pending pick
    var busy = false;
    var selfDispatch = false;      // true while WE dispatch wm:cart:update, so our own listener no-ops

    function primaryId() { return primary ? String(primary.productId) : null; }
    function primaryInCart() { return !!(primary && cartPicks[primaryId()]); }
    function primaryItem() {
      if (primary && cartPicks[primaryId()]) return cartPicks[primaryId()];
      return pendingPrimary;
    }
    function primarySelected() { return !!primaryItem(); }
    function otherCartPicks() {
      return Object.keys(cartPicks)
        .filter(function (k) { return !primary || k !== primaryId(); })
        .map(function (k) { return cartPicks[k]; });
    }
    function pickList() {
      var out = [];
      var p = primaryItem();
      if (p) out.push(p);
      otherCartPicks().forEach(function (i) { out.push(i); });
      return out;
    }

    /* ----------------------------- money ----------------------------- */
    function formatMoney(cents) {
      function withDelims(num, precision, thousands, decimal) {
        precision = isNaN(precision) ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        if (num == null || isNaN(num)) return '0';
        var value = (num / 100.0).toFixed(precision);
        var parts = value.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents2 = parts[1] ? decimal + parts[1] : '';
        return dollars + cents2;
      }
      var out;
      var match = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
      var token = match ? match[1] : 'amount';
      switch (token) {
        case 'amount': out = withDelims(cents, 2); break;
        case 'amount_no_decimals': out = withDelims(cents, 0); break;
        case 'amount_with_comma_separator': out = withDelims(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = withDelims(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': out = withDelims(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = withDelims(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': out = withDelims(cents, 2, "'", '.'); break;
        default: out = withDelims(cents, 2);
      }
      return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, out);
    }

    /* ----------------------------- pricing ----------------------------- */
    function tierForCount(count) {
      var applied = null;
      for (var i = 0; i < TIERS.length; i++) { if (count >= TIERS[i].qty) applied = TIERS[i]; }
      return applied;
    }
    function nextTier(count) {
      for (var i = 0; i < TIERS.length; i++) {
        if (TIERS[i].qty > count && TIERS[i].pct > 0) return TIERS[i];
      }
      return null;
    }
    function compute() {
      var items = pickList();
      var count = items.length;
      var subtotal = items.reduce(function (s, i) { return s + i.price; }, 0);
      var tier = tierForCount(count);
      var pct = tier ? tier.pct : 0;
      var total = Math.round(subtotal * (100 - pct) / 100);
      return { count: count, subtotal: subtotal, total: total, savings: subtotal - total, pct: pct, tier: tier };
    }

    /* ----------------------------- product variant lookups ----------------------------- */
    function variantById(id) {
      for (var i = 0; i < pVariants.length; i++) { if (String(pVariants[i].id) === String(id)) return pVariants[i]; }
      return null;
    }
    function isWmaVariant(id) {
      var v = variantById(id);
      return v ? !!v.wma : false;
    }

    /* ----------------------------- software (DAW) + version → primary variant ----------------------------- */
    function pickPrimaryVariant() {
      if (!selectedDaw) return null;
      if (hasVer && !selectedVer) return null;
      var matches = pVariants.filter(function (v) {
        return String(v.daw) === selectedDaw && (!hasVer || String(v.ver) === selectedVer);
      });
      var chosen = null;
      for (var i = 0; i < matches.length; i++) { if (matches[i].available) { chosen = matches[i]; break; } }
      if (!chosen && matches.length) chosen = matches[0];
      return chosen;
    }
    function refreshAvailability() {
      verButtons.forEach(function (b) {
        var ver = b.getAttribute('data-pb-ver');
        b.disabled = !pVariants.some(function (v) {
          return String(v.ver) === ver && v.available && (!selectedDaw || String(v.daw) === selectedDaw);
        });
      });
      dawButtons.forEach(function (b) {
        var daw = b.getAttribute('data-pb-daw');
        b.disabled = !pVariants.some(function (v) {
          return String(v.daw) === daw && v.available && (!hasVer || !selectedVer || String(v.ver) === selectedVer);
        });
      });
      soldOut = dawButtons.length > 0 && dawButtons.every(function (b) { return b.disabled; });
    }
    function syncSwUI() {
      dawButtons.forEach(function (b) {
        var on = b.getAttribute('data-pb-daw') === selectedDaw;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      verButtons.forEach(function (b) {
        var on = b.getAttribute('data-pb-ver') === selectedVer;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (swHint) {
        if (selectedDaw && (!hasVer || selectedVer)) {
          swHint.textContent = selectedDaw + (hasVer && selectedVer ? ' · ' + selectedVer : '');
        } else {
          swHint.textContent = swHint.getAttribute('data-hint') || 'Choose one';
        }
      }
    }
    // Build the pendingPrimary from the current software selection (display/preview only,
    // not yet in the cart). For single-variant products it's the lone variant.
    function recomputePending() {
      if (dawButtons.length === 0) { pendingPrimary = defaultPrimaryPick; return; }
      var v = pickPrimaryVariant();
      if (v && v.available && primary) {
        pendingPrimary = {
          productId: primaryId(), variantId: String(v.id),
          price: v.price, title: primary.title || '', image: primary.image || '', wma: !!v.wma
        };
      } else {
        pendingPrimary = null;
      }
    }
    function commitPrimary() {
      recomputePending();
      syncSwUI();
      render();
    }
    function applyPrimarySelection() {
      // Once the primary is in the cart, changing the DAW swaps the cart line's
      // variant; before that it's just a price preview.
      if (primaryInCart()) changePrimaryVariant();
      else commitPrimary();
    }
    function selectDaw(btn) {
      if (!btn || btn.disabled) return;
      selectedDaw = btn.getAttribute('data-pb-daw');
      if (hasVer && selectedVer) {
        var okV = pVariants.some(function (v) { return String(v.daw) === selectedDaw && String(v.ver) === selectedVer && v.available; });
        if (!okV) selectedVer = null;
      }
      refreshAvailability();
      // If the chosen software has exactly one available version, select it
      // automatically so single-version options (e.g. WMA) commit in one click.
      if (hasVer) {
        var avVer = verButtons.filter(function (b) { return !b.disabled; });
        if (avVer.length === 1) selectedVer = avVer[0].getAttribute('data-pb-ver');
      }
      applyPrimarySelection();
    }
    function selectVer(btn) {
      if (!btn || btn.disabled) return;
      selectedVer = btn.getAttribute('data-pb-ver');
      if (selectedDaw) {
        var okD = pVariants.some(function (v) { return String(v.daw) === selectedDaw && String(v.ver) === selectedVer && v.available; });
        if (!okD) selectedDaw = null;
      }
      refreshAvailability();
      applyPrimarySelection();
    }
    // Reflect the cart's chosen primary variant in the selector (cart wins on sync).
    function reflectPrimaryFromCart() {
      if (!primary) return;
      var inCart = cartPicks[primaryId()];
      if (inCart) {
        pendingPrimary = null;
        var v = variantById(inCart.variantId);
        if (v) {
          selectedDaw = v.daw != null ? String(v.daw) : selectedDaw;
          selectedVer = hasVer ? (v.ver != null ? String(v.ver) : null) : null;
          refreshAvailability();
          syncSwUI();
        }
      } else {
        // primary not in the cart — keep the current selection as a pending preview
        recomputePending();
      }
    }

    /* ----------------------------- modal cards ----------------------------- */
    function readVariant(card) {
      var ctrl = card.querySelector('[data-bundle-variant]');
      if (!ctrl) return null;
      var variantId, price, wma = false;
      if (ctrl.tagName === 'SELECT') {
        var opt = ctrl.options[ctrl.selectedIndex];
        if (!opt) return null;
        variantId = opt.value;
        price = parseInt(opt.getAttribute('data-price'), 10);
        wma = opt.getAttribute('data-wma') === 'true';
      } else {
        variantId = ctrl.value;
        price = parseInt(ctrl.getAttribute('data-price'), 10);
      }
      if (isNaN(price)) price = parseInt(card.dataset.price, 10) || 0;
      var imgEl = card.querySelector('.wm-bcard__img');
      return {
        productId: String(card.dataset.productId),
        variantId: variantId,
        price: price,
        title: card.dataset.title || '',
        image: imgEl ? (imgEl.currentSrc || imgEl.src) : '',
        wma: wma
      };
    }
    function cardById(id) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].dataset.productId === String(id)) return cards[i];
      }
      return null;
    }
    function syncCard(card) {
      var added = !!cartPicks[card.dataset.productId];
      card.classList.toggle('is-added', added);
      var btn = card.querySelector('[data-bundle-add]');
      if (btn) {
        btn.setAttribute('aria-pressed', added ? 'true' : 'false');
        var label = btn.querySelector('.wm-bcard__add-label');
        if (label) label.textContent = added ? 'Added' : 'Add';
      }
    }
    // Display-only: keep each card's shown price in step with its selected DAW
    // (the WMA option is half off), and toggle the "with WMA plugin" cue.
    function repriceCard(card) {
      var ctrl = card.querySelector('[data-bundle-variant]');
      if (!ctrl || ctrl.tagName !== 'SELECT') return;
      if (ctrl._wmSyncPicker) ctrl._wmSyncPicker();
      var opt = ctrl.options[ctrl.selectedIndex];
      if (!opt) return;
      var nowEl = card.querySelector('[data-bcard-price-now]');
      var wasEl = card.querySelector('[data-bcard-price-was]');
      var hintEl = card.querySelector('[data-bcard-wma-hint]');
      var priceDisplay = opt.getAttribute('data-price-display');
      var compareDisplay = opt.getAttribute('data-compare-display');
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var compare = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      var isWma = opt.getAttribute('data-wma') === 'true';
      var onSale = !isNaN(price) && compare > price;
      if (nowEl && priceDisplay) nowEl.textContent = priceDisplay;
      if (wasEl) { wasEl.hidden = !onSale; if (onSale && compareDisplay) wasEl.textContent = compareDisplay; }
      if (hintEl) hintEl.hidden = !isWma;
    }
    function refreshModalCap() {
      var full = otherCartPicks().length >= (MAX_PICKS - 1);
      cards.forEach(function (card) {
        var btn = card.querySelector('[data-bundle-add]');
        if (!btn) return;
        btn.disabled = full && !cartPicks[card.dataset.productId];
      });
    }

    /* ----------------------------- cart sync ----------------------------- */
    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function cartFetch(url, body) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
      });
    }
    function applySection(sections, id, selector) {
      if (!sections || typeof sections[id] !== 'string') return;
      var target = document.querySelector(selector);
      if (!target) return;
      try {
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var src = doc.querySelector(selector) || doc.getElementById(id);
        if (src) target.innerHTML = src.innerHTML;
      } catch (e) { /* noop */ }
    }
    function updateCartUI(data) {
      if (!data) return;
      applySection(data.sections, 'cart-icon-bubble', '#cart-icon-bubble');
      applySection(data.sections, 'cart-drawer', '#CartDrawer');
      selfDispatch = true;
      document.dispatchEvent(new CustomEvent('wm:cart:update', { detail: data }));
      selfDispatch = false;
    }
    function syncFromCart() {
      return getCart().then(function (cart) {
        cartPicks = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties[CART_PROP]) {
            cartPicks[String(it.product_id)] = {
              productId: String(it.product_id),
              variantId: it.variant_id,
              price: it.original_price != null ? it.original_price : it.price,
              title: it.product_title || it.title || '',
              image: it.image || (it.featured_image && it.featured_image.url) || '',
              key: it.key,
              wma: isWmaVariant(it.variant_id) || !!(it.properties && it.properties.Compatibility)
            };
          }
        });
        reflectPrimaryFromCart();
        cards.forEach(syncCard);
        render();
      }).catch(function () { /* leave current state */ });
    }

    /* ----------------------------- mutate (cart) ----------------------------- */
    function cartAddVariant(variantId, wma) {
      var props = {}; props[CART_PROP] = '1';
      if (wma) props.Compatibility = (WMA && WMA.value) || 'Wav Monopoly Audio';
      return cartFetch(CART_ADD_URL, { items: [{ id: variantId, quantity: 1, properties: props }] });
    }
    function cartRemoveKey(key) {
      return cartFetch('/cart/change.js', { id: key, quantity: 0 });
    }
    // Change a bundle line's variant: remove the old line, then ONLY add the new
    // variant if the remove actually succeeded — otherwise we'd leave two _wm_bundle
    // lines for the same product (a double charge). Re-sync either way so the panel
    // snaps back to the cart's real state on failure.
    function swapCartLine(oldKey, newVariantId, wma) {
      return cartRemoveKey(oldKey).then(function (resp) {
        if (!resp || !resp.ok) {
          showError((resp && resp.data && resp.data.description) || 'Could not update your selection.');
          return syncFromCart();
        }
        updateCartUI(resp.data);
        return cartAddVariant(newVariantId, wma).then(function (resp2) {
          if (!resp2 || !resp2.ok) showError((resp2 && resp2.data && resp2.data.description) || 'Could not update your selection.');
          else updateCartUI(resp2.data);
          return syncFromCart();
        });
      });
    }
    function addCard(card) {
      var data = readVariant(card);
      if (!data || !data.variantId) return Promise.resolve();
      if (!cartPicks[card.dataset.productId] && otherCartPicks().length >= (MAX_PICKS - 1)) return Promise.resolve(); // bundle full
      return cartAddVariant(data.variantId, data.wma).then(function (resp) {
        if (!resp || !resp.ok) { showError((resp && resp.data && resp.data.description) || 'Could not add to cart.'); return; }
        updateCartUI(resp.data);
        return syncFromCart();
      });
    }
    function removeItem(productId) {
      var item = cartPicks[productId];
      if (!item || !item.key) return Promise.resolve();
      return cartRemoveKey(item.key).then(function (resp) {
        if (resp && resp.ok) updateCartUI(resp.data);
        return syncFromCart();
      });
    }
    function toggleCard(card) {
      guarded(function () {
        return cartPicks[card.dataset.productId] ? removeItem(card.dataset.productId) : addCard(card);
      });
    }
    // Swap the in-cart primary line to a newly selected variant (remove old + add new).
    function changePrimaryVariant() {
      var v = pickPrimaryVariant();
      syncSwUI();
      if (!v || !v.available) { render(); return; }
      var current = cartPicks[primaryId()];
      if (!current) { commitPrimary(); return; }
      if (String(current.variantId) === String(v.id)) { render(); return; } // no change
      guarded(function () { return swapCartLine(current.key, v.id, !!v.wma); });
    }
    // Main button: add the primary (then go to /cart), or — if already added — go to /cart.
    function primaryAction() {
      if (busy) return;
      if (primaryInCart()) { window.location.href = REDIRECT; return; }
      var p = pendingPrimary;
      if (!p || !p.variantId) return;
      guarded(function () {
        return cartAddVariant(p.variantId, !!p.wma).then(function (resp) {
          if (!resp || !resp.ok) { showError((resp && resp.data && resp.data.description) || 'Could not add to cart. Please try again.'); return; }
          updateCartUI(resp.data);
          window.location.href = REDIRECT;
        });
      });
    }
    function guarded(fn) {
      if (busy) return;
      busy = true; setBusy(true);
      Promise.resolve(fn()).catch(function () { showError('Something went wrong. Please try again.'); })
        .then(function () { busy = false; setBusy(false); });
    }
    function setBusy(on) {
      root.classList.toggle('wm-prh--busy', on);
      if (checkoutBtn) checkoutBtn.classList.toggle('is-loading', on);
      renderSticky();
    }

    /* ----------------------------- render ----------------------------- */
    function renderTierSlots() {
      var count = pickList().length;
      var added = otherCartPicks();
      var inCart = primaryInCart();
      var pitem = primaryItem();
      var currentQty = -1;
      stopEls.forEach(function (cell) {
        var qty = parseInt(cell.getAttribute('data-tier-qty'), 10);
        if (count >= qty && qty > currentQty) currentQty = qty;
      });
      stopEls.forEach(function (cell, i) {
        var qty = parseInt(cell.getAttribute('data-tier-qty'), 10);
        var slotEl = cell.querySelector('[data-pb-slot]');
        var filled = false;
        if (slotEl) {
          if (i === 0) {
            // first cell holds the current product (the primary pick)
            var pimg = (pitem && pitem.image) ? pitem.image : (primary && primary.image);
            var ptitle = (pitem && pitem.title) || (primary && primary.title) || '';
            if (pimg) {
              var pmedia = '<img src="' + escapeAttr(pimg) + '" alt="' + escapeAttr(ptitle) + '">';
              // only removable once it's actually in the cart
              if (inCart) {
                pmedia += '<button type="button" class="wm-prh__slot-remove" data-pb-remove="' + escapeAttr(primaryId()) + '" aria-label="Remove ' + escapeAttr(ptitle) + '">&times;</button>';
              }
              slotEl.innerHTML = pmedia;
            } else {
              slotEl.innerHTML = '<span class="wm-prh__slot-ph">' + escapeHtml((ptitle || '?').charAt(0)) + '</span>';
            }
            slotEl.removeAttribute('data-pb-add-slot');
            filled = primarySelected();
          } else {
            var it = added[i - 1];
            if (it) {
              var media = it.image
                ? '<img src="' + escapeAttr(it.image) + '" alt="' + escapeAttr(it.title) + '">'
                : '<span class="wm-prh__slot-ph">' + escapeHtml((it.title || '?').charAt(0)) + '</span>';
              slotEl.innerHTML = media + '<button type="button" class="wm-prh__slot-remove" data-pb-remove="' + escapeAttr(it.productId) + '" aria-label="Remove ' + escapeAttr(it.title) + '">&times;</button>';
              slotEl.removeAttribute('data-pb-add-slot');
              filled = true;
            } else {
              slotEl.innerHTML = '<span class="wm-prh__slot-ph">+</span>';
              slotEl.setAttribute('data-pb-add-slot', '');
              filled = false;
            }
          }
        }
        cell.classList.toggle('is-filled', filled);
        cell.classList.toggle('is-active', count >= qty);
        cell.classList.toggle('is-current', qty === currentQty);
      });
    }

    /* ----------------------------- WMA price truthfulness ----------------------------- */
    // The selected variant's price IS the source of truth (WMA variant = half off).
    function currentUnit() {
      var p = primaryItem();
      return p ? p.price : STANDALONE;
    }
    function updateHeroPrice() {
      var v = pickPrimaryVariant();
      var nowEl = root.querySelector('[data-pb-price-now]');
      var wasEl = root.querySelector('[data-pb-price-was]');
      var pillEl = root.querySelector('[data-pb-price-pill]');
      var price = v ? v.price : STANDALONE;
      var compareAt = v ? v.compareAt : STANDALONE_COMPARE;
      if (nowEl) nowEl.textContent = formatMoney(price);
      var onSale = !!(compareAt && compareAt > price);
      if (wasEl) { wasEl.hidden = !onSale; if (onSale) wasEl.textContent = formatMoney(compareAt); }
      if (pillEl) {
        if (onSale) { pillEl.hidden = false; pillEl.textContent = Math.round((compareAt - price) * 100 / compareAt) + '% off'; }
        else { pillEl.hidden = true; pillEl.textContent = ''; }
      }
    }
    function updateTierEach() {
      var unit = currentUnit();
      root.querySelectorAll('[data-pb-tier-each]').forEach(function (el) {
        var pct = parseInt(el.getAttribute('data-tier-pct'), 10) || 0;
        el.innerHTML = formatMoney(Math.round(unit * (100 - pct) / 100)) + '<small>each</small>';
      });
    }
    function updateWmaNote() {
      var noteWmaEl = root.querySelector('[data-pb-wma-note]');
      var ctaEl = root.querySelector('[data-pb-wma-cta]');
      var p = primaryItem();
      var isWma = !!(p && p.wma);
      if (noteWmaEl) {
        var showNote = isWma && WMA && WMA.note && !WMA.subscribed;
        noteWmaEl.hidden = !showNote;
        if (showNote) noteWmaEl.textContent = WMA.note;
      }
      // "Get the WMA plugin" CTA → Moonbase subscription (shown only once the URL is set)
      if (ctaEl) {
        var showCta = isWma && WMA && WMA.pluginUrl && !WMA.subscribed;
        ctaEl.hidden = !showCta;
        if (showCta) { ctaEl.href = WMA.pluginUrl; ctaEl.textContent = (WMA.ctaLabel || 'Get the WMA Plugin') + ' →'; }
      }
    }

    function render() {
      var r = compute();
      var inCart = primaryInCart();
      var selected = primarySelected();
      updateHeroPrice();
      updateTierEach();
      updateWmaNote();
      renderTierSlots();
      refreshModalCap();

      // Before any pick exists, keep the Liquid-rendered base price (don't flash $0.00).
      if (totalEl) totalEl.textContent = formatMoney(r.count > 0 ? r.total : ((primary && primary.price) || r.total));
      if (totalWasEl) {
        if (r.savings > 0) { totalWasEl.textContent = formatMoney(r.subtotal); totalWasEl.hidden = false; }
        else totalWasEl.hidden = true;
      }
      if (saveEl) {
        if (r.savings > 0) { saveEl.hidden = false; if (saveAmtEl) saveAmtEl.textContent = formatMoney(r.savings); }
        else saveEl.hidden = true;
      }

      if (addCountEl) {
        var addedCount = otherCartPicks().length;
        addCountEl.textContent = addedCount > 0 ? '(' + addedCount + ')' : '';
      }

      if (checkoutBtn) {
        var labelEl = checkoutBtn.querySelector('[data-pb-checkout-label]') || checkoutBtn;
        if (inCart) {
          checkoutBtn.disabled = false;
          labelEl.textContent = (checkoutBtn.getAttribute('data-label-incart') || 'View cart') + ' — ' + formatMoney(r.total);
        } else if (!selected) {
          checkoutBtn.disabled = true;
          if (soldOut) labelEl.textContent = checkoutBtn.getAttribute('data-label-soldout') || 'Sold out';
          else labelEl.textContent = checkoutBtn.getAttribute('data-label-empty') || 'Select your software first';
        } else if (r.count > 1) {
          checkoutBtn.disabled = false;
          labelEl.textContent = (checkoutBtn.getAttribute('data-label-bundle') || 'Add bundle to cart') + ' — ' + formatMoney(r.total);
        } else {
          checkoutBtn.disabled = false;
          labelEl.textContent = (checkoutBtn.getAttribute('data-label-single') || 'Add to cart') + ' — ' + formatMoney(r.total);
        }
      }

      if (noteEl) {
        if (!selected) noteEl.textContent = noteEl.getAttribute('data-note-empty') || 'Choose your software to continue';
        else {
          var next = nextTier(r.count);
          if (next) noteEl.textContent = 'Add ' + (next.qty - r.count) + ' more preset' + ((next.qty - r.count) === 1 ? '' : 's') + ' to save ' + next.pct + '%';
          else if (r.pct > 0) noteEl.textContent = inCart ? ('In your cart • ' + r.pct + '% bundle discount applied') : (r.pct + '% bundle discount applied at checkout');
          else noteEl.textContent = inCart ? 'In your cart' : (noteEl.getAttribute('data-note-ready') || 'Instant download • Lifetime updates');
        }
      }
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      renderSticky();
    }

    /* ----------------------------- modal filtering ----------------------------- */
    function applyFilters() {
      if (!cards.length) return;
      var q = (searchInput && searchInput.value || '').trim().toLowerCase();
      var daw = (dawSelect && dawSelect.value) || '';
      var visible = 0;
      cards.forEach(function (card) {
        var title = (card.dataset.title || '').toLowerCase();
        var daws = (card.dataset.daws || '').split(',').map(function (s) { return s.trim(); });
        var matchSearch = !q || title.indexOf(q) !== -1;
        var matchDaw = !daw || daws.indexOf(daw) !== -1;
        var show = matchSearch && matchDaw;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (searchClear) searchClear.classList.toggle('is-visible', !!q);
    }
    function applySort() {
      if (!sortSelect || !grid) return;
      var mode = sortSelect.value;
      var arr = cards.slice();
      arr.sort(function (a, b) {
        if (mode === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
        if (mode === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
        if (mode === 'title-asc') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        return (+a.dataset.position) - (+b.dataset.position);
      });
      var frag = document.createDocumentFragment();
      arr.forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
    }
    function buildDawOptions() {
      if (!dawSelect) return;
      var set = {};
      cards.forEach(function (card) {
        (card.dataset.daws || '').split(',').forEach(function (d) {
          d = d.trim();
          if (d) set[d] = true;
        });
      });
      var names = Object.keys(set).sort();
      names.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        dawSelect.appendChild(opt);
      });
      if (names.length === 0) {
        var field = dawSelect.closest('.wm-bfield');
        if (field) field.style.display = 'none';
      }
    }

    /* ----------------------------- modal open/close ----------------------------- */
    function openModal() {
      if (!modal) return;
      lastFocus = document.activeElement;
      if (dawSelect && selectedDaw && Array.from(dawSelect.options).some(function (o) { return o.value === selectedDaw.toLowerCase(); })) {
        dawSelect.value = selectedDaw.toLowerCase();
        applyDawSelection();
      }
      modal.hidden = false;
      updateStickyVisibility();
      document.body.classList.add('wm-pbm-open');
      var focusTarget = modal.querySelector('[data-bundle-search]') || modal.querySelector('[data-pb-close]');
      if (focusTarget) focusTarget.focus();
      document.addEventListener('keydown', onKeydown);
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      updateStickyVisibility();
      document.body.classList.remove('wm-pbm-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var focusables = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      focusables = Array.prototype.slice.call(focusables).filter(function (el) {
        return el.offsetParent !== null; // visible only
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function showError(msg) {
      if (!errorEl) { window.alert(msg); return; }
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    /* ----------------------------- escaping ----------------------------- */
    function escapeHtml(s) {
      return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
    }
    function escapeAttr(s) {
      return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }

    /* ----------------------------- events ----------------------------- */
    dawButtons.forEach(function (btn) { btn.addEventListener('click', function () { selectDaw(btn); }); });
    verButtons.forEach(function (btn) { btn.addEventListener('click', function () { selectVer(btn); }); });
    cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-bundle-add]');
      if (addBtn) addBtn.addEventListener('click', function () { toggleCard(card); });
      var ctrl = card.querySelector('[data-bundle-variant]');
      if (ctrl && ctrl.tagName === 'SELECT') {
        repriceCard(card);
        ctrl.addEventListener('change', function () {
          repriceCard(card);
          var existing = cartPicks[card.dataset.productId];
          if (existing && existing.key) {
            var data = readVariant(card);
            if (data && data.variantId) {
              guarded(function () { return swapCartLine(existing.key, data.variantId, data.wma); });
            }
          }
        });
      }
    });
    if (tiersEl) {
      tiersEl.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-pb-remove]');
        if (rm) { var id = rm.getAttribute('data-pb-remove'); guarded(function () { return removeItem(id); }); return; }
        if (e.target.closest('[data-pb-add-slot]')) openModal();
      });
    }
    openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-pb-close]') || e.target.hasAttribute('data-pb-backdrop')) closeModal();
      });
    }
    if (searchInput) searchInput.addEventListener('input', applyFilters);
    if (searchClear) searchClear.addEventListener('click', function () { searchInput.value = ''; applyFilters(); searchInput.focus(); });
    if (sortSelect) sortSelect.addEventListener('change', applySort);
    function applyDawSelection() {
      var daw = (dawSelect && dawSelect.value || '').toLowerCase();
      if (daw) cards.forEach(function (card) {
        if (cartPicks[card.dataset.productId]) return;
        var control = card.querySelector('select[data-bundle-variant]');
        if (!control) return;
        var current = control.options[control.selectedIndex];
        var choices = Array.from(control.options).filter(function (option) {
          return !option.disabled && option.getAttribute('data-daw') === daw;
        });
        var match = choices.find(function (option) {
          return current && option.getAttribute('data-version') === current.getAttribute('data-version');
        }) || choices[0];
        if (match) { control.value = match.value; repriceCard(card); }
      });
      applyFilters();
    }
    if (dawSelect) dawSelect.addEventListener('change', applyDawSelection);
    if (checkoutBtn) checkoutBtn.addEventListener('click', primaryAction);

    // re-sync if the cart changes elsewhere (e.g. collection bundle, cart drawer).
    // Skip our own dispatch (we sync explicitly), and skip a stale instance whose root
    // was detached by shopify:section:load — its listener lingers but must no-op.
    document.addEventListener('wm:cart:update', function () {
      if (selfDispatch) return;
      if (root.isConnected === false) return;
      syncFromCart();
    });

    /* ----------------------------- boot ----------------------------- */
    buildDawOptions();
    applySort();
    applyFilters();

    // Single-variant product (no selector): the lone variant is the pending primary.
    if (dawButtons.length === 0 && primary) {
      var vid = root.getAttribute('data-pb-default-variant');
      var vprice = parseInt(root.getAttribute('data-pb-default-price'), 10);
      if (vid) {
        defaultPrimaryPick = {
          productId: primaryId(), variantId: vid,
          price: isNaN(vprice) ? (primary.price || 0) : vprice,
          title: primary.title || '', image: primary.image || '', wma: false
        };
        pendingPrimary = defaultPrimaryPick;
      }
    } else {
      refreshAvailability();
      // Default to the Wav Monopoly Audio (half-off) option when it exists —
      // selectDaw() auto-picks its sole version, so the page lands on $24.99
      // with the "requires plugin" disclosure already visible. Display only —
      // nothing is added to the cart until the shopper clicks Add.
      var wmaBtn = null;
      if (WMA && WMA.value) {
        wmaBtn = dawButtons.filter(function (b) {
          return b.getAttribute('data-pb-daw') === WMA.value && !b.disabled;
        })[0] || null;
      }
      if (wmaBtn) {
        selectDaw(wmaBtn);
      } else {
        var avDaws = dawButtons.filter(function (b) { return !b.disabled; });
        if (avDaws.length === 1) selectDaw(avDaws[0]);
        var avVers = verButtons.filter(function (b) { return !b.disabled; });
        if (hasVer && avVers.length === 1) selectVer(avVers[0]);
      }
    }

    root._wmSync = syncFromCart;
    render();
    syncFromCart();   // rebuild from the cart so the bundle persists + reflects the chosen variant
  }

  function boot() {
    document.querySelectorAll('[data-preset-bundle]').forEach(init);
  }
  // restore from the cart when returning via the back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('[data-preset-bundle]').forEach(function (r) { if (r._wmSync) r._wmSync(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-preset-bundle]') : null;
    if (root) init(root);
  });
})();
